import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { RouteCachingService } from '../../services/route-caching.service';

/** the navigation menu and all his items */
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.template.html'
})
export class SidenavComponent {
  @Input('items') public menuItems: any[] = [];
  @Input('hasIconMenu') public hasIconTypeMenuItem: boolean = false;
  @Input('iconMenuTitle') public iconTypeMenuTitle: string = '';
  @ViewChild('sidenav') sidenav!: ElementRef;

  constructor(private _routeCachingService: RouteCachingService) { }
  ngOnInit() { }
  ngAfterViewInit() {
    setTimeout(() => {
      const links = this.sidenav.nativeElement.querySelectorAll('li[appdropdownlink]');
      [...links].forEach(link => {
        if (link.querySelector('a.open')) {
          link.classList.add('open');
        }
      })
    })
  }

  public onMenuItemClick(e: any): void {
    // clear all cached components when navigating using the menu in order to refresh the data
    this._routeCachingService.clearCachedRoutes();
  }

  // Only for demo purpose
  addMenuItem() {
    this.menuItems.push({
      name: 'ITEM',
      type: 'dropDown',
      tooltip: 'Item',
      icon: 'done',
      state: 'material',
      sub: [
        { name: 'SUBITEM', state: 'cards' },
        { name: 'SUBITEM', state: 'buttons' }
      ]
    });
  }
}
